import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const resizeObserverErr = window.console.error;

window.console.error = (...args) => {
  if (args[0]?.toString().includes("ResizeObserver loop")) {
    return;
  }
  resizeObserverErr(...args);
};

const originalError = console.error;

console.error = (...args) => {
  if (
    args[0]?.includes?.(
      "ResizeObserver loop completed with undelivered notifications"
    )
  ) {
    return;
  }
  originalError(...args);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
